import ready from "./helper_functions/ready";
import {ShopTrackingEvents} from "./shop/tracking/events";
import {ShopTracking} from "./shop/shopTracking";
import {DataLayerHelper} from "./shop/tracking/dataLayerHelper";

/**
 * @type {{CUSTOMFROMSHOP: string, OWNLISTENERSHOP: string}}
 */
export const TRACKING_EVENT_TYPE = {
    CUSTOMFROMSHOP: 'customfromshop',
    OWNLISTENERSHOP: 'ownlistenershop',
    CLICKLISTENERSHOP: 'clicklistenershop',
    SUBMITLISTENERSHOP: 'submitlistenershop'
}

/**
 * @type {{CLICK: string, VIEW: string, ADD: string, REMOVE: string}}
 */
export const TRACKING_EVENT_CATEGORY = {
    CLICK: 'click',
    VIEW: 'view',
    ADD: 'add',
    REMOVE: 'remove',
    CHANGE: 'change',
    SELECT: 'select',
    SEARCH: 'search',
    FORM: 'form',
    ERROR: 'error'
};

/**
 * Handle all shop tracking events!
 */
ready(function () {

    /**
     * Class instance to handle all the tracking events for b2c shop.
     *
     * @type {ShopTracking}
     */
    const shopTracking = new ShopTracking();

    // Add to cart event
    document.body.addEventListener(
        ShopTrackingEvents.CUSTOM_EVENT_ADD_TO_CART,
        (event) => {

            let detail = {};

            if ('detail' in event) {

                detail = event.detail;
            }

            shopTracking.trackCustomEvent(
                TRACKING_EVENT_TYPE.CUSTOMFROMSHOP,
                detail,
                DataLayerHelper.ADD_TO_CART_EVENT,
                TRACKING_EVENT_CATEGORY.ADD
            );
        }
    );

    // Remove from cart event
    document.body.addEventListener(
        ShopTrackingEvents.CUSTOM_EVENT_REMOVE_FROM_CART,
        (event) => {

            let detail = {};

            if ('detail' in event) {

                detail = event.detail;
            }

            /**
             * Detail in this case is holding the tracking data
             * (ShopTrackingEvents.CUSTOM_EVENT_PARMETER_TRACKING_DATA).
             * So we can use it driectly and route to a method that handles the tracking data.
             */
            let data = {};
            if (detail.hasOwnProperty(ShopTrackingEvents.CUSTOM_EVENT_PARMETER_TRACKING_DATA) ) {
                data = detail[ShopTrackingEvents.CUSTOM_EVENT_PARMETER_TRACKING_DATA] ?? {};
                data = JSON.parse(data) ?? {};
            }

            shopTracking.trackCustomEventWithTwigExtensionData(
                TRACKING_EVENT_TYPE.CUSTOMFROMSHOP,
                data,
                DataLayerHelper.REMOVE_FROM_CART_EVENT,
                TRACKING_EVENT_CATEGORY.REMOVE
            );
        }
    );

    // Add to wishlist event
    document.body.addEventListener(
        ShopTrackingEvents.CUSTOM_EVENT_ADD_TO_WISHLIST,
        (event) => {

            let detail = {};

            if ('detail' in event) {

                detail = event.detail;
            }

            shopTracking.trackCustomEvent(
                TRACKING_EVENT_TYPE.CUSTOMFROMSHOP,
                detail,
                DataLayerHelper.ADD_TO_WISH_LIST_EVENT,
                TRACKING_EVENT_CATEGORY.ADD
            );
        }
    );

    // Remove from wishlist event
    document.body.addEventListener(
        ShopTrackingEvents.CUSTOM_EVENT_REMOVE_FROM_WISHLIST,
        (event) => {

            let detail = {};

            if ('detail' in event) {

                detail = event.detail;
            }

            shopTracking.trackCustomEvent(
                TRACKING_EVENT_TYPE.CUSTOMFROMSHOP,
                detail,
                DataLayerHelper.REMOVE_FROM_WISH_LIST_EVENT,
                TRACKING_EVENT_CATEGORY.REMOVE
            );
        }
    );

    // Add to request cart event
    document.body.addEventListener(
        ShopTrackingEvents.CUSTOM_EVENT_ADD_TO_REQUEST_CART,
        (event) => {

            let detail = {};

            if ('detail' in event) {

                detail = event.detail;
            }

            shopTracking.trackCustomEvent(
                TRACKING_EVENT_TYPE.CUSTOMFROMSHOP,
                detail,
                DataLayerHelper.ADD_TO_REQUEST_CART_EVENT,
                TRACKING_EVENT_CATEGORY.ADD
            );
        }
    );

    // Change/Add shipping information event
    document.body.addEventListener(
        ShopTrackingEvents.CUSTOM_EVENT_ADD_SHIPPING_INFO,
        (event) => {

            let detail = {};

            if ('detail' in event) {

                detail = event.detail;
            }

            let element = null;

            if ('element' in detail) {

                element = detail.element;
            }

            shopTracking.trackClickEventBasedOnTrackingData(
                element,
                event,
                DataLayerHelper.ADD_SHIPPING_INFO
            )
        }
    );

    /**
     * Listener that handles custom event triggered from included twig based custom event script.
     * The include script is using a corresponding twig extension holding function
     * buildDetailCustomEventTrackingData.
     */
    document.body.addEventListener(
        ShopTrackingEvents.CUSTOM_EVENT_VIEW_CART,
        (event) => {

            let detail = {};

            if ('detail' in event) {

                detail = event.detail;
            }

            shopTracking.trackCustomEvent(
                TRACKING_EVENT_TYPE.OWNLISTENERSHOP,
                detail,
                DataLayerHelper.VIEW_CART_EVENT,
                TRACKING_EVENT_CATEGORY.VIEW
            )
        }
    )

    /**
     * Select wishlist and tracking the click event.
     */
    const submenuFavorites = document.querySelectorAll('.submenu-favorite');
    submenuFavorites.forEach(function (element) {

        element.addEventListener("click", function (event) {

            // Just trigger the event if it is triggered by a user.
            if (event.isTrusted === false) {
                return;
            }

            shopTracking.trackClickEvent(
                element,
                event,
                DataLayerHelper.CLICK_WISH_LIST_EVENT,
            );
        });
    });


    /**
     * Select request cart and tracking the click event.
     */
    const submenuRequest = document.querySelectorAll('.submenu-request');
    submenuRequest.forEach(function (element) {

        element.addEventListener("click", function (event) {

            // Just trigger the event if it is triggered by a user.
            if (event.isTrusted === false) {
                return;
            }

            shopTracking.trackClickEvent(
                element,
                event,
                DataLayerHelper.CLICK_REQUEST_LIST_EVENT,
            );
        });
    });

    /**
     * Select profile and tracking the click event.
     */
    const submenuProfile = document.querySelectorAll('.submenu-profile');
    submenuProfile.forEach(function (element) {

        element.addEventListener("click", function (event) {

            // Just trigger the event if it is triggered by a user.
            if (event.isTrusted === false) {
                return;
            }

            shopTracking.trackClickEvent(
                element,
                event,
                DataLayerHelper.CLICK_PROFILE_EVENT,
            );
        });
    });

    /**
     * Select search form and tracking the search event.
     */
    const sparePartsSearchForms = document.querySelectorAll('.spare-parts-search-form');
    sparePartsSearchForms.forEach(function (element) {

        element.addEventListener("submit", function (event) {

            // Just trigger the event if it is triggered by a user.
            if (event.isTrusted === false) {
                return;
            }

            // Are different tracking events as both forms have same class.
            shopTracking.trackFormSubmitEvent(
                element,
                event
            );
        });
    });

    // Add coupon event
    const couponElements = document.querySelectorAll('.cart-add-promotion');
    couponElements.forEach(function (element) {

        element.addEventListener("submit", function (event) {

            // Just trigger the event if it is triggered by a user.
            if (event.isTrusted === false) {
                return;
            }

            shopTracking.trackFormSubmitEvent(
                element,
                event
            );
        });
    });

    // Begin checkout event (triggered by a button)
    const checkoutButton = document.querySelectorAll('.begin-checkout-button');
    checkoutButton.forEach(function (element) {

        element.addEventListener("click", function (event) {

            // Just trigger the event if it is triggered by a user.
            if (event.isTrusted === false) {
                return;
            }

            shopTracking.trackClickEventBasedOnTrackingData(
                element,
                event,
                DataLayerHelper.BEGIN_CHECKOUT_EVENT,
            );
        });
    });

    /**
     * Listener that handles custom event triggered from included twig based custom event script.
     * It's used to track the checkout step 1 process.
     */
    document.body.addEventListener(
        ShopTrackingEvents.CUSTOM_EVENT_CHECKOUT_STEP_1,
        (event) => {

            let detail = {};

            if ('detail' in event) {

                detail = event.detail;
            }

            shopTracking.trackCustomEventWithTwigExtensionData(
                TRACKING_EVENT_TYPE.OWNLISTENERSHOP,
                detail,
                DataLayerHelper.CHECKOUT_STEP_1_EVENT,
                TRACKING_EVENT_CATEGORY.VIEW
            )
        }
    )

    /**
     * Listener that handles custom event triggered from included twig based custom event script.
     * It's used to track the checkout step 2 process.
     */
    document.body.addEventListener(
        ShopTrackingEvents.CUSTOM_EVENT_CHECKOUT_STEP_2,
        (event) => {

            let detail = {};

            if ('detail' in event) {

                detail = event.detail;
            }

            shopTracking.trackCustomEventWithTwigExtensionData(
                TRACKING_EVENT_TYPE.OWNLISTENERSHOP,
                detail,
                DataLayerHelper.CHECKOUT_STEP_2_EVENT,
                TRACKING_EVENT_CATEGORY.VIEW
            )
        }
    )

    /**
     * Listener that handles custom event triggered from included twig based custom event script.
     * It's used to track the checkout step 3 process.
     *
     * IMPORTANT NOTE:
     * This event also sets an entry to the local storage to be able to track the
     * order success event. This is necessary as the thank-you page just provides an order id in view
     * and i don't want to interfere with the controller logic.
     */
    document.body.addEventListener(
        ShopTrackingEvents.CUSTOM_EVENT_CHECKOUT_STEP_3,
        (event) => {

            let detail = {};

            if ('detail' in event) {

                detail = event.detail;
            }

            shopTracking.trackCustomEventWithTwigExtensionData(
                TRACKING_EVENT_TYPE.OWNLISTENERSHOP,
                detail,
                DataLayerHelper.CHECKOUT_STEP_3_EVENT,
                TRACKING_EVENT_CATEGORY.VIEW
            )
        }
    )

    /**
     * Listener that handles custom event triggered from included twig based custom event script.
     * Tracks changes on the payment method.
     */
    const checkoutPaymentFormInputs = document.querySelectorAll('.payment-methods label[data-tracking-payment-type]');
    checkoutPaymentFormInputs.forEach(function (element) {

        element.addEventListener("click", function (event) {

            // Just trigger the event if it is triggered by a user.
            if (event.isTrusted === false) {
                return;
            }

            shopTracking.trackClickEventBasedOnTrackingData(
                element,
                event,
                DataLayerHelper.ADD_PAYMENT_INFO
            );
        });
    });

    /**
     * Click event on step 1 continue button while user is logged in and has an address.
     */
    const checkoutContinueButtonStep1User = document.querySelector('.account-overview-address a[data-tracking-checkout-step1-user]');
    if (checkoutContinueButtonStep1User) {

        checkoutContinueButtonStep1User.addEventListener("click", function (event) {

            // Just trigger the event if it is triggered by a user.
            if (event.isTrusted === false) {
                return;
            }

            shopTracking.trackCustomizedClickEvent(
                checkoutContinueButtonStep1User,
                event,
                DataLayerHelper.CHECKOUT_STEP_1_EVENT,
            );
        });
    }

    /**
     * Click event on step 1 continue button while proceeding as guest
     */
    const checkoutContinueButtonStep1Guest = document.querySelector('.form-row button[data-tracking-checkout-step1-guest]');
    if (checkoutContinueButtonStep1Guest) {

        checkoutContinueButtonStep1Guest.addEventListener("click", function (event) {
            //event.preventDefault();

            // Just trigger the event if it is triggered by a user.
            if (event.isTrusted === false) {
                return;
            }

            shopTracking.trackCustomizedClickEvent(
                checkoutContinueButtonStep1Guest,
                event,
                DataLayerHelper.CHECKOUT_STEP_1_EVENT,
            );
        });
    }

    /**
     * Click event on step 1 continue button while proceeding as new customer.
     */
    const checkoutContinueButtonStep1New = document.querySelector('.form-row button[data-tracking-checkout-step1-new]');
    if (checkoutContinueButtonStep1New) {

        checkoutContinueButtonStep1New.addEventListener("click", function (event) {

            // Just trigger the event if it is triggered by a user.
            if (event.isTrusted === false) {
                return;
            }

            shopTracking.trackCustomizedClickEvent(
                checkoutContinueButtonStep1New,
                event,
                DataLayerHelper.CHECKOUT_STEP_1_EVENT,
            );
        });
    }

    /**
     * Event on select of country in step 1 of the checkout process. This tracking event is used
     * to see if the country in form is changed to a country which not matches cart country (selected
     * via tax popup).
     */
    const checkoutCountrySelect = document.getElementById('checkout_address_form_country');
    if (checkoutCountrySelect &&
        checkoutCountrySelect.selectize
    ) {

        const selectizeInstance = checkoutCountrySelect.selectize;

        // On change event on selectize instance
        selectizeInstance.on('change', (value) => {


            shopTracking.trackCheckoutCountryMismatch(
                checkoutCountrySelect,
                value
            );
        });

        const actualItem = selectizeInstance['items'] ?? null;

        // check if array is empty
        if (Array.isArray(actualItem) &&
            actualItem.length > 0
        ) {
            shopTracking.trackCheckoutCountryMismatch(
                checkoutCountrySelect,
                actualItem[0]
            );
        }
    }

    /**
     * Click event on step 2 continue button.
     */
    const checkoutContinueButtonStep2 = document.querySelector('.checkout-main button[data-continue-to-order]');
    if (checkoutContinueButtonStep2) {

        checkoutContinueButtonStep2.addEventListener("click", function (event) {
            shopTracking.trackCustomizedClickEvent(
                checkoutContinueButtonStep2,
                event,
                DataLayerHelper.CHECKOUT_STEP_2_EVENT,
            );
        })
    }

    /**
     * This construct is used to track form errors in the checkout process as well as the
     * click event on the continue button.
     */
    const checkoutContinueButtonStep3 = document.querySelector('.checkout-main button[data-continue-to-purchase]');
    if (checkoutContinueButtonStep3) {

        checkoutContinueButtonStep3.addEventListener("click", function (event) {

            // Prüfe ob das form ok ist
            const form = checkoutContinueButtonStep3.closest('form');

            if (form) {

                if (form.checkValidity() === false) {
                    const formName = form.getAttribute('name');
                    let errorFields = [];

                    // Iterate all fields
                    const invalidFields = form.querySelectorAll(':invalid');
                    invalidFields.forEach(function (invalidField) {

                        const fieldName = invalidField.getAttribute('name');
                        const fieldValidity = invalidField.validity;

                        errorFields.push({
                            fieldName: fieldName,
                            fieldValidity: ShopTracking.getErrorDescription(fieldValidity)
                        })

                    });

                    shopTracking.trackFormErrorEvent(
                        form,
                        formName,
                        errorFields
                    );
                }

                shopTracking.trackCustomizedClickEvent(
                    checkoutContinueButtonStep3,
                    event,
                    DataLayerHelper.CHECKOUT_STEP_3_EVENT,
                );
            }
        })
    }

    /**
     * This is about general forms in the checkout process.
     * As they are marked with a html5 attribute to mark them as mandatory, we can track them.
     */
    const generalCheckoutMainForms = document.querySelectorAll('.checkout-main form');
    generalCheckoutMainForms.forEach(function (element) {

        element.addEventListener("submit", function (event) {

            if (element.checkValidity() === false) {
                const formName = element.getAttribute('name');
                let errorFields = [];

                // Iterate all fields
                const invalidFields = element.querySelectorAll(':invalid');
                invalidFields.forEach(function (invalidField) {

                    const fieldName = invalidField.getAttribute('name');
                    const fieldValidity = invalidField.validity;

                    errorFields.push({
                        fieldName: fieldName,
                        fieldValidity: ShopTracking.getErrorDescription(fieldValidity)
                    })

                });

                shopTracking.trackFormErrorEvent(
                    element,
                    formName,
                    errorFields
                );
            }
        });
    });

    /**
     * Handle form errors which come in a defined structure from the server (AJAX).
     * The validity errors are collected and tracked in another method using the submit event.
     * See: const generalCheckoutMainForms = document.querySelectorAll('.checkout-main form');
     */
    const forms = document.querySelectorAll('.checkout-main form');
    // iterate over all forms in the checkout area
    forms.forEach(form => {

        const collectServerErrors = () => {
            const errorFields = [];

            // Search for all error groups in the form
            const errorGroups = form.querySelectorAll('div.form-group.filled.error');

            // iterate them nodes
            errorGroups.forEach(group => {

                const inputField = group.querySelector('input, select, textarea');
                const fieldName = inputField?.name || 'unknown';
                const errorMessages = group.querySelectorAll('ul.form-error > li');

                // Collect errors for each field
                errorMessages.forEach(error => {
                    const errorText = error.innerText.trim() ?? 'unknown';

                    errorFields.push({
                        fieldName: fieldName,
                        errorMessage: errorText
                    });
                });
            });

            // If we got errors, track them
            if (errorFields.length > 0) {
                const formName = form.getAttribute('name') || 'unnamed form';

                shopTracking.trackFormErrorEvent(
                    form,
                    formName,
                    errorFields
                );
            }
        };

        // New observer with the given method.
        const observer = new MutationObserver(() => {

            // Trigger every time the DOM gets changed
            collectServerErrors();
        });

        // Set up the observer to watch for changes in the form
        observer.observe(
            form,
            {
                childList: true,
                subtree: true
            }
        );

        // Check if errors are already present.
        collectServerErrors();
    });

    /**
     * Add simple tracking for the on button.
     */
    const editAddresseOnCheckoutConfirm =
        document.querySelectorAll('.confirm-address-billing button, .confirm-address-shipping button');
    editAddresseOnCheckoutConfirm.forEach(function (element) {

        element.addEventListener("click", function (event) {

            // Just trigger the event if it is triggered by a user.
            if (event.isTrusted === false) {
                return;
            }

            shopTracking.trackCustomizedClickEvent(
                element,
                event,
                DataLayerHelper.EDIT_CONFIRM_ADDRESS_EVENT,
            );
        });
    });

    /**
     * Add another google standard tracking event for view_item
     */
    document.body.addEventListener(
        ShopTrackingEvents.CUSTOM_EVENT_VIEW_ITEM,
        (event) => {

            let detail = {};

            if ('detail' in event) {

                detail = event.detail;
            }

            shopTracking.trackCustomEvent(
                TRACKING_EVENT_TYPE.OWNLISTENERSHOP,
                detail,
                DataLayerHelper.VIEW_ITEM_EVENT,
                TRACKING_EVENT_CATEGORY.VIEW
            )
        }
    )

    /**
     * Handle checkout error (global) and track them.
     */
    const mainCheckoutContent = document.querySelector('.checkout-main');
    if (mainCheckoutContent) {
        const handleCheckoutErrors = () => {
            const errorDivs = mainCheckoutContent.querySelectorAll('.checkout-error');

            errorDivs.forEach(error => {

                const errorText = error?.innerText.trim() ?? 'Unknow error has occurred';

                shopTracking.trackGlobalErrorEvent(
                    error,
                    errorText
                );
            });
        };

        // Call to ensure that errors are tracked on page load
        handleCheckoutErrors();

        const checkoutErrorObserver = new MutationObserver(() => {
            handleCheckoutErrors();
        });
        checkoutErrorObserver.observe(
            mainCheckoutContent,
            {
                childList: true,
                subtree: true
            }
        );
    }

    /**
     * Add another google standard tracking event for purchase.
     * Its using local storage data from step 3 to track the order success correctly.
     * It's as well using data from the event (order id) to complete the tracking.
     */
    document.body.addEventListener(
        ShopTrackingEvents.CUSTOM_EVENT_VIEW_PURCHASE,
        (event) => {

            let detail = {};

            if ('detail' in event) {

                detail = event.detail;
            }

            shopTracking.trackCustomEventUsingLocalStorageData(
                TRACKING_EVENT_TYPE.OWNLISTENERSHOP,
                detail,
                DataLayerHelper.PURCHASE_EVENT,
                TRACKING_EVENT_CATEGORY.VIEW
            )
        }
    )
});